import React, { useState } from "react";
import VendorKnowledge from "../../NewCompoents/Rag/VendorKnowledge";
import CreateInboundAgentComponent from "../CreateAgentComponent/CreateInBoundAgentComponent";
import CreateOutboundAgentComponent from "../CreateAgentComponent/CreateOutBoundAgentComponent";
import PromptManager from "../Script&Api/ScriptandApi";
import styles from "./MultiStepForm.module.css";

const MultiStepForm = () => {
  const [step, setStep] = useState(1);
  const [note, setNote] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isInbound = window.location.pathname.includes("/inbound/createagent");

  const handleNext = async () => {
    if (step >= 3) return;
    if (!note.trim()) {
      alert("Please enter a note in the popup.");
      return;
    }

    try {
      const authData = JSON.parse(localStorage.getItem("authData"));
      console.log("authData:", authData);
      if (!authData?.token || !authData?.user?.name) {
        alert("User not authenticated. Please log in.");
        return;
      }

      console.log("Sending request:", { note, step, isInbound });
      const response = await fetch(
        "https://prod.toxboxai.com/api/requests/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authData.token}`,
          },
          body: JSON.stringify({ note, step, isInbound }),
        }
      );

      console.log("Response status:", response.status);
      const data = await response.json();
      console.log("Response data:", data);

      if (response.ok) {
        setStep(step + 1);
        setNote("");
        setIsModalOpen(false);
        alert("Request submitted successfully!");
      } else {
        alert(data.message || "Failed to submit request");
      }
    } catch (error) {
      console.error("Error submitting request:", error);
      alert("Server error. Please try again later.");
    }
  };

  const handleSkip = () => {
    if (step < 3) setStep(step + 1);
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleStepClick = (stepNumber) => {
    setStep(stepNumber);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setNote("");
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return <PromptManager />;
      case 2:
        return <VendorKnowledge />;
      case 3:
        return isInbound ? (
          <CreateInboundAgentComponent />
        ) : (
          <CreateOutboundAgentComponent />
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.progressBar}>
        <div className={styles.progressStep}>
          <div
            className={`${styles.stepCircle} ${step >= 1 ? styles.active : ""}`}
            onClick={() => handleStepClick(1)}
            tabIndex={0}
            role="button"
            aria-label="Go to Prompt step"
          >
            1
          </div>
          <p className={styles.stepLabel}>Prompt</p>
        </div>
        <div
          className={`${styles.progressLine} ${step >= 2 ? styles.activeLine : ""
            }`}
        ></div>
        <div className={styles.progressStep}>
          <div
            className={`${styles.stepCircle} ${step >= 2 ? styles.active : ""}`}
            onClick={() => handleStepClick(2)}
            tabIndex={0}
            role="button"
            aria-label="Go to Knowledge Base step"
          >
            2
          </div>
          <p className={styles.stepLabel}>Knowledge Base</p>
        </div>
        <div
          className={`${styles.progressLine} ${step >= 3 ? styles.activeLine : ""
            }`}
        ></div>
        <div className={styles.progressStep}>
          <div
            className={`${styles.stepCircle} ${step >= 3 ? styles.active : ""}`}
            onClick={() => handleStepClick(3)}
            tabIndex={0}
            role="button"
            aria-label={`Go to ${isInbound ? "Inbound" : "Outbound"
              } Agent Creation step`}
          >
            3
          </div>
          <p className={styles.stepLabel}>
            {isInbound ? "Inbound Agent Creation" : "Outbound Agent Creation"}
          </p>
        </div>
      </div>

      <div className={styles.content}>
        {renderStepContent()}
        {(step === 1 || step === 2) && (
          <div className={styles.buttonGroup}>
            <button onClick={handleSkip} className={styles.skipButton}>
              Skip
            </button>
            <button onClick={openModal} className={styles.nextButton}>
              Request to Add {step === 1 ? "Prompt" : "Knowledge Base"}
            </button>
          </div>
        )}
        {step === 3 && (
          <div className={styles.buttonGroup}>
            <button onClick={handleBack} className={styles.skipButton}>
              Back
            </button>
          </div>
        )}
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h3>Enter Note</h3>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Enter your note here"
              className={styles.noteInput}
            />
            <div className={styles.modalButtons}>
              <button onClick={closeModal} className={styles.cancelButton}>
                Cancel
              </button>
              <button
                onClick={handleNext}
                className={styles.submitButton}
                disabled={!note.trim()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiStepForm;
